import superagent from 'superagent';
import { backendUrl } from '@helpers/consts';
const API_URL = `${backendUrl}/carrierPerformance`;

export const carrierPerformanceService = {
  getAll: async () => {
    const response = await superagent.get(API_URL)
    .set("Authorization", `Bearer ${localStorage.getItem("authJWT")}`)
    .set("accept", "json")
    .set("Content-Type", "application/json");
    return response.body;
  },

  getById: async (id) => {
    const response = await superagent.get(`${API_URL}/${id}`)
    .set("Authorization", `Bearer ${localStorage.getItem("authJWT")}`)
    .set("accept", "json")
    .set("Content-Type", "application/json");
    return response.body;
  },

  create: async (data) => {
    const response = await superagent.post(API_URL).send(data)
    .set("Authorization", `Bearer ${localStorage.getItem("authJWT")}`)
    .set("accept", "json")
    .set("Content-Type", "application/json");
    return response.body;
  },

  update: async (id, data) => {
    const response = await superagent.patch(`${API_URL}/${id}`).send(data)
    .set("Authorization", `Bearer ${localStorage.getItem("authJWT")}`)
    .set("accept", "json")
    .set("Content-Type", "application/json");
    return response.body;
  },

  delete: async (id) => {
    await superagent.delete(`${API_URL}/${id}`)
    .set("Authorization", `Bearer ${localStorage.getItem("authJWT")}`)
    .set("accept", "json")
    .set("Content-Type", "application/json");
  },

  getCountryAndState: async () => {
    const response = await superagent.get(`${API_URL}/getCountryAndState`)
    .set("Authorization", `Bearer ${localStorage.getItem("authJWT")}`)
    .set("accept", "json")
    .set("Content-Type", "application/json");
    return response.body;
  },

  getCarrierName: async () => {
    const response = await superagent.get(`${API_URL}/getCarrierName`)
    .set("Authorization", `Bearer ${localStorage.getItem("authJWT")}`)
    .set("accept", "json")
    .set("Content-Type", "application/json");
    return response.body;
  }
};

export default carrierPerformanceService;
